// Estado de entrega de un saliente de WhatsApp o Instagram.
//
// Misma regla que `EstadoEntrega` en el backend: un estado nuevo solo se aplica
// si su rango es mayor que el actual, para que dos eventos STOMP que lleguen
// desordenados no hagan retroceder el tick.
//
//   null | received | desconocido = 0 < sent = 1 < failed = 2 < delivered = 3 < read = 4

const RANGOS = { sent: 1, failed: 2, delivered: 3, read: 4 };

export const rangoEstado = (estado) =>
  (estado && RANGOS[String(estado).toLowerCase()]) || 0;

export const estadoAvanza = (actual, nuevo) => rangoEstado(nuevo) > rangoEstado(actual);

/**
 * Ids externos a los que se aplica un evento: la lista `messageIds` del evento en
 * bloque (una lectura de Instagram que marca varios salientes de un chat) o el
 * `messageId` del evento de un solo mensaje.
 */
const idsDelEvento = (evento) => {
  if (Array.isArray(evento.messageIds)) return new Set(evento.messageIds);
  return evento.messageId ? new Set([evento.messageId]) : null;
};

/**
 * Aplica un evento de `/topic/bots.{botId}.message-status` a una lista de
 * mensajes. Casa por id externo: `id` en el Dashboard y `messageId` en la
 * bandeja de atención. Acepta el evento de un mensaje (`messageId`) y el de
 * varios (`messageIds`). Devuelve el mismo array si nada cambia, para no
 * provocar renders.
 */
export const aplicarEstadoEntrega = (mensajes, evento) => {
  if (!mensajes || !evento) return mensajes;
  const ids = idsDelEvento(evento);
  if (!ids || ids.size === 0) return mensajes;
  let cambiado = false;
  const resultado = mensajes.map((m) => {
    const id = m.id ?? m.messageId;
    if (!ids.has(id) || !estadoAvanza(m.deliveryStatus, evento.status)) return m;
    cambiado = true;
    return {
      ...m,
      deliveryStatus: evento.status,
      deliveryErrorCode: evento.errorCode ?? null,
      deliveryErrorMessage: evento.errorMessage ?? null,
    };
  });
  return cambiado ? resultado : mensajes;
};

/**
 * Si un evento de estado puede tocar un chat cargado: mismo chat externo y, si
 * los dos la traen, misma plataforma. Un evento sin `chatId` no descarta nada,
 * porque el id del mensaje ya basta para casar.
 */
export const eventoEsDelChat = (chat, evento) => {
  if (!chat) return false;
  if (evento.chatId == null) return true;
  if (String(chat.chatId) !== String(evento.chatId)) return false;
  return !chat.platform || !evento.platform || chat.platform === evento.platform;
};
